const navToggles = document.querySelectorAll('.nav-toggle');
const navBar = document.querySelector('#navbar');

navToggles.forEach((navToggle) => {
  navToggle.addEventListener('click', () => {
    navBar.classList.toggle('max-lg:left-0');
  });
});
